var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":"Pays"}},[_c('b-form-select',{attrs:{"options":_vm.options,"value":_vm.pays},on:{"change":function (v) { return _vm.$emit('change', v); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }